import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';

import { SPECIAL_AGENT_IDS } from '@/entities/agent';
import { getCurrentOrganizationId } from '@/entities/user';
import { useCurrentWorkspaceId } from '@/entities/workspace';
import { startChatSession, useChatStore } from '@/features/chats';
import { personaLabel } from '@/shared/lib/persona-label';

interface PersonaToTalkTo {
  personaId: string;
  personaTitle?: string;
  segmentName?: string;
}

export const useStartPersonaChat = () => {
  const { t } = useTranslation('analysis');
  const navigate = useNavigate();
  const workspaceId = useCurrentWorkspaceId();

  return async ({ personaId, personaTitle, segmentName }: PersonaToTalkTo) => {
    await useChatStore.getState().setAgentById(SPECIAL_AGENT_IDS.AUDIENCE_FLOW);

    const personaName = personaLabel({ personaTitle, segmentName });

    await startChatSession(useChatStore.getState().initializeChat, navigate, {
      agentId: SPECIAL_AGENT_IDS.AUDIENCE_FLOW,
      prompt: t('analysisResult.iqpersonaDetail.iWantToSpeakWith', { personaName }),
      inputs: { personaId },
      visibilityScope: {
        workspaceId,
        organizationId: getCurrentOrganizationId(),
      },
    });
  };
};
